import { execute } from '@/api/execute'
import { GET, PUT, POST, DELETE } from '@/api/types'
import { addQueryParams } from '@/util/index.js'

import loadings from './loadings'

const ENDPOINT = 'schedule/schedules'

export default {
  loadings,

  list (params = {}) {
    return execute(GET, addQueryParams(`${ENDPOINT}/`, params))
  },

  create (payload) {
    return execute(POST, `${ENDPOINT}/`, payload)
  },

  createByOrder (payload) {
    return execute(POST, `${ENDPOINT}/ordering/`, payload)
  },

  getById (id) {
    return execute(GET, `${ENDPOINT}/${id}/`)
  },

  updateById (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/`, payload)
  },

  updateLoad (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/load/`, payload)
  },

  updateUpload (id, payload) {
    return execute(PUT, `${ENDPOINT}/${id}/upload/`, payload)
  },

  deleteById (id) {
    return execute(DELETE, `${ENDPOINT}/${id}/`)
  }
}
